import { FUNDS } from "../actionTypes";

const initialState = {
    funds: [],
    arrTradingPower: [],
    transactionListGrid: [],
    balanceInformation: [],
    fundMarginDetails: [],
    fundsBreakups: {},
    questionAnswers: [],
    periodicities: [],
    productWiseBalance: {},
    peridiocityWiseBalanceAndType: [],
    peridiocityWiseBalance: [],
    peridiocityWisefundsBreakup: [],
    transferMappedProduct: [],
    allowedMarkets: [],
    UPIDetails: [], // Hari K:10-11-2023: maintaining state for UIP Details
    bankAccList: [],// Hari K:10-11-2023: maintaining state for bank accounts details
    mappedBankList: [],
    objWithdrawalSession: [],
    objTransferFunds: [],
    isTransactionAPI: false, // Hari K:10-11-2023: maintaining state for API failure
    dicTrHolidayMaster: [], // Hari K:22-02-2023 :BT-119138: maintaining state for non business days
    availableBankList: [], // Hari K:22-02-2023 :BT-119138: to maintain state for available banks
    isTransactionPending: false,
    isPeriodicityWiseBalancePending: false,
    objFundsWithDrawalcancel: {}
};

const fundsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case FUNDS.GET_FUNDS:
            return {
                ...state,
                questionAnswers: [{
                    id: 1,
                    questionText: 'What is Trading Power?',
                    answerText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
                },
                {
                    id: 2,
                    questionText: 'What is Available funds?',
                    answerText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
                },
                {
                    id: 3,
                    questionText: 'How do I add funds in a particular segment?',
                    answerText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
                },
                {
                    id: 4,
                    questionText: 'How do I view my Used margin from Trading power?',
                    answerText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
                },]
                ,
                funds: [{
                    id: '1', indraday: '50000', delivery: '12000', mtf: '5900', myfunds: '1500'
                }],
                arrTradingPower: [
                    {
                        id: '1', trading_type: 'Intraday', data: {
                            remaining_balance: '50000',
                            total_amt: '250000',
                        }
                    },
                    {
                        id: '2', trading_type: 'Delivery', data: {
                            remaining_balance: '12000',
                            total_amt: '20000',
                        }
                    },
                    {
                        id: '3', trading_type: 'MTF', data: {
                            remaining_balance: '5900',
                            total_amt: '10000',
                        }
                    }]
            };
        case FUNDS.GET_FUNDS_BREAKUPS:
            return {
                ...state,
                fundsBreakups: {
                    fundsBreakupCash: [
                        {
                            title: 'Cash Deposit',
                            fundPrice: 80
                        },
                        {
                            title: 'National Deposit',
                            fundPrice: 20
                        },
                        {
                            title: 'Adhoc Deposit',
                            fundPrice: 100
                        },
                        {
                            title: 'Overdraft Limit',
                            fundPrice: 100
                        },
                        {
                            title: 'Misc. Deposit',
                            fundPrice: 200
                        },
                        {
                            title: 'Manual Collateral',
                            fundPrice: 0.0
                        }
                    ],
                    fundsBreakupCollaterals: [
                        {
                            title: 'DP Collateral',
                            fundPrice: 0.0
                        },
                        {
                            title: 'Poor Collateral',
                            fundPrice: 100
                        },
                        {
                            title: 'SAR Collateral',
                            fundPrice: 100
                        },
                        {
                            title: 'DP Pledged Collateral',
                            fundPrice: 100
                        },
                        {
                            title: 'Pool Pledged Collateral',
                            fundPrice: 700
                        },
                        {
                            title: 'Maximum Collateral',
                            fundPrice: 0.0
                        },
                        {
                            title: 'Maximum Collateral Limit',
                            fundPrice: 0.0
                        }
                    ]
                }
            };
        case FUNDS.GET_AVAILABLE_BANK_LIST_SUCCESS: // Hari K:22-02-2023 :BT-119138: to update availableBanklist state
            return {
                ...state,
                availableBankList: actions.payload
            };
        case FUNDS.GET_TRANSACTION_PENDING_STATE:
            return { ...state, isTransactionPending: actions.payload };
        case FUNDS.GET_PERIODICITY_WISE_BALACE_PENDING_STATE:
            return { ...state, isPeriodicityWiseBalancePending: actions.payload };
        case FUNDS.GET_NON_BUSINESS_SUCCESS: // Hari K:22-02-2023 :BT-119138: to update dicrHolidayMaster state
            return {
                ...state,
                dicTrHolidayMaster: actions.payload
            };
        case FUNDS.GET_ALLOWED_MARKETS_SUCCESS: // Hari K:10-11-2023: maintaining state
            return {
                ...state,
                allowedMarkets: actions.payload
            };
        case FUNDS.TRANSFER_FUNDS_SUCCESS: // Hari K:10-11-2023: maintaining state
            return {
                ...state,
                objTransferFunds: actions.payload
            };
        case FUNDS.WITHDRAWAL_SUCCESS: // Hari K:10-11-2023: maintaining state
            return {
                ...state,
                objWithdrawalSession: actions.payload

            };
        case FUNDS.GET_BANK_ACCOUNTS_LIST_SUCCESS: // Hari K:10-11-2023: maintaining state for banl accounts details
            return {
                ...state,
                bankAccList: actions.payload
            };
        case FUNDS.GET_MAPPED_BANK_LIST_SUCCESS:
            return {
                ...state,
                mappedBankList: actions.payload
            };
        case FUNDS.UPI_DETAILS_SUCCESS: // Hari K:10-11-2023: added UIP Details 
            return {
                ...state,
                UPIDetails: actions.payload
            };
        case FUNDS.FUNDS_REPORT_SUCCESS: {
            return {
                ...state,
                isTransactionAPI: false,
                transactionListGrid: actions.payload
            };
        }
        case FUNDS.WITHDRAWAL_FUNDS_CANCEL_SUCCESS:
            return {
                ...state,
                objFundsWithDrawalcancel: actions.payload
            };
        case FUNDS.WITHDRAWAL_FUNDS_CANCEL_FAILURE:
            return {
                ...state,
                objFundsWithDrawalcancel: actions.payload
            };
        case FUNDS.FUNDS_REPORT_FAILURE: { // Hari K:10-11-2023: updating state on API failure
            return {
                ...state,
                isTransactionAPI: true,
                transactionListGrid: []
            };
        }
        case FUNDS.GET_PERIODIOCITIES_SUCCESS:
            return {
                ...state,
                periodicities: actions.payload
            };
        case FUNDS.GET_PERIODIOCITIES_FAILURE:
            return {
                ...state,
                periodicities: actions.payload
            };
        case FUNDS.PRODUCT_WISE_BALANCE_SUCCESS:
            return {
                ...state,
                productWiseBalance: actions.payload
            };
        case FUNDS.SET_PERIODIOCITY_WISE_FUNDS_BREAKUP:
            return {
                ...state,
                peridiocityWisefundsBreakup: actions.payload
            };
        case FUNDS.PERIODIOCITY_WISE_BALANCE_TYPE_SUCCESS:
            return {
                ...state,
                peridiocityWiseBalanceAndType: actions.payload
            };
        case FUNDS.PERIODIOCITY_WISE_BALANCE_SUCCESS:
            return {
                ...state,
                peridiocityWiseBalance: actions.payload
            };
        // case FUNDS.PERIODIOCITY_WISE_BALANCE_FAILURE:
        //     return {
        //         ...state,
        //         peridiocityWiseBalance: actions.payload
        //     };
        case FUNDS.TRANSFER_MAPPED_PRODUCTS_SUCCESS:
            return {
                ...state,
                transferMappedProduct: actions.payload
            };
        default:
            return state;
    }
};

export default fundsReducer;